import { Navigate, Route, Routes } from 'react-router-dom';
import { CalendarPlanning } from './content/calendar/providers/calendar-planning';
import { TableShiftPlanningProvider } from './content/table/shift-planning-table';

export const PlanningRoutes = () => {
  return (
    <Routes>
      <Route index element={<Navigate to="calendar" replace />} />
      <Route path="calendar" element={<CalendarPlanning />} />
      <Route path="table" element={<TableShiftPlanningProvider />} />
    </Routes>
  );
};
